export default "__VITE_PUBLIC_ASSET__609ab0d1__"